
import React, { useContext, useEffect,useState,useRef } from 'react';
import { Web3ModalContext } from '../../contexts/Web3ModalProvider';
import { Web3WrapperContext } from '../../contexts/Web3WrapperProvider';
import { NotificationManager } from 'react-notifications';
import { useAppDispatch, useAppSelector } from "../../hooks/redux";
import { setDashboard } from "../../store/reducers/DashboardSlice";
import { Oval } from "react-loader-spinner";
import '../../../node_modules/bootstrap/dist/css/bootstrap.min.css'
import { swapBO,defaultChainId,networkNames } from '../../blockchain/constants';
import {Animated} from "react-animated-css";
import TagManager from 'react-gtm-module'


const axios = require('axios');





export default function Swap() {

 

  const [bar, setBar] = useState(0);
  const [swap1input, setSwap1input] = useState<number>();
  const [swap2input, setSwap2input] = useState<number>();
  const [amount, setAmount] = useState();
  const [animation, setAnimation] = useState(false);
  const ref = useRef();

  const [maxTSupply, setTMaxSupply] = useState(5);

  const { web3Wrapper: wrapper } = useContext(Web3WrapperContext);
  const dispatch = useAppDispatch();
  


  const { connect, account } = useContext(Web3ModalContext);
  const { chainId } = useContext(Web3ModalContext);
  useEffect(() => {
    getMarketCapDetails()
}, []);

useEffect(() => {
  if (chainId !== null && Number(chainId) !== Number(defaultChainId)) {
    NotificationManager.error(`Try on ${networkNames[defaultChainId]}`, "Wrong Network");
  }
}, [chainId]);





function handleChange(e) {

  setSwap1input(e.target.value);
  axios.get(swapBO.apiBaseURL+'getData?_ApplicationId='+swapBO.apiBaseURL+'&address='+account+'&amount='+e.target.value).then(resp => {
   
  var tokenCanSwap = resp.data.result; 
  
  tokenCanSwap=tokenCanSwap.toFixed(2); 
  setSwap2input(tokenCanSwap); 
  setAmount(e.target.value);
});
}

function getMarketCapDetails() {
  axios.get(swapBO.apiBaseURL+'getMetaData?_ApplicationId='+swapBO.apiBaseURL+'').then(resp => {
   
  var maxSupply = resp.data.result.maxSupply; 
  var totalCoin2with55 = resp.data.result.totalCoin2with55;
  var totalCoin2 = resp.data.result.totalCoin2;
  var getPercentage=(totalCoin2with55/maxSupply)*10;



  setBar(getPercentage); 
  console.log(getPercentage);
  setTMaxSupply(maxSupply);
});
}

const swap = async () => {

  const tagManagerArgs = {
    gtmId: 'GTM-MZCKWFH',
    events: {
        ClickOnSwap: 'ClickOnSwap'
    }
}
 
TagManager.initialize(tagManagerArgs);
console.log("asdasdds");

NotificationManager.error(`Seed Phase is FINISHED!!!`, "Failed")
return 0;

  // if (amount == 0 || amount == undefined) NotificationManager.error(`Please input Crace amount`, "Invalid Amount");
  // else if (amount < 0) NotificationManager.error(`Amount must be greater than 0`, "Invalid Amount");
  // else if (amount > 1000000000) NotificationManager.error(`Amount must be lesser than 1000000000`, "Invalid Amount");
  // else {
  //     let modal: any = document.getElementById("myModal");
  //     modal.style.display = "block";
    
  //     const addresss=account;
  //         let result = await wrapper?.swap(addresss,amount);
  //         if (result == 1) { NotificationManager.success(`Transfer Successfully`, "Confirmed");
  //         dispatch(setDashboard(0));
  //     }
  //         if (result == 2) {NotificationManager.error(`Transfer has suspended,`, "Failed");
  //         dispatch(setDashboard(0));
  //         }
  //         let a=0;
  //         setSwap1input(0);
  //         setSwap2input(0);
  //         modal.style.display = "none";
      

  // }
}

const RoadMap = async () => {
  window.open('/Relaunch_AMA.pdf', '_blank');
  
};

const setp1funtion = async () => {
  window.open('https://pancakeswap.finance/swap?outputCurrency=0xfbb4f2f342c6daab63ab85b0226716c4d1e26f36', '_blank');
};
const setp2funtion = async () => {
  window.scrollTo(0, document.body.scrollHeight || document.documentElement.scrollHeight);
  setAnimation(true);

  setTimeout(() => {
    setAnimation(false);
  }, 1000);


};
const setp3funtion = async () => {
  window.location.href="/game";
};
const setp4funtion = async () => {
  window.open('https://discord.com/invite/AqWHXP3Jk7', '_blank');;
};


  return (
    <div className="topright"  >
         <div className="img-top-home">
            <img width="90%" src="images/bar.png" alt="" />
          </div>
          <div className="seed-process">
            <h3 className="text-white text-seed mb-0 "> Seed Phase Process </h3>
            <img className="pos-line" width="80%" src="images/SeedPhase_Bar.png" alt="" />
          </div>
          <div className="container-fluid">
            <div className="row d-flex justify-content-center row-1-top">
              
              <div className="col-lg col-md-12 col-sm-12 col-xs-12 seed-phase1">
                <h4 className="text-center p-seed-heading">STEP 1</h4>
                <p className="text-center p-seed">BUY CRACE V1 TOKENS</p>
                <div className=" d-flex justify-content-center">
                  <img onClick={setp1funtion} className="curserPointer img-seed-button1" width="65%" src="images/SeedPhase_BuyButton.png" />
                </div>
              </div>
              <div className="col-lg-auto d-flex align-items-center">
                <img src="images/CapFillBar1.png" width="35px; margin: 0 auto;" />
              </div>

              <div className="col-lg col-md-12 col-sm-12  col-xs-12  seed-phase1">
                <h4 className="text-center  p-seed-heading">STEP 2</h4>
                <p  className="text-center p-seed">SWAP V1 TOKENS FOR V2 TOKENS IN OUR DAPP</p>
                <div className=" d-flex justify-content-center">
                  <img onClick={setp2funtion}  className="img-seed-button2 curserPointer" width="65%" src="images/swapbutton.png" />
                </div>
              </div>
              <div className="col-lg-auto d-flex align-items-center">
                <img src="images/CapFillBar1.png" width="35px; margin: 0 auto;" />
              </div>

              <div className="col-lg  col-md-12 col-sm-12 col-xs-12  seed-phase1" >
                <h4 className="text-center p-seed-heading">STEP 3</h4>
                <p className="text-center p-seed">Tokens will be airdropped on V2 LAUNCH</p>
                <div className=" d-flex justify-content-center">
                  <img onClick={setp3funtion}  className="img-seed-button3 curserPointer" width="65%" src="images/SeedPhase_PlayButton.png" />
                </div>
              </div>

              <div className="col-lg-auto d-flex align-items-center">
                <img src="images/CapFillBar1.png" width="35px; margin: 0 auto;" />
              </div>

              <div className="col-lg  col-md-12 col-sm-12 col-xs-12  seed-phase1" >
                <h4 className="text-center p-seed-heading">STEP 4</h4>
                <p className="text-center p-seed">BECOME A COINRACER VIP</p>
                <div className=" d-flex justify-content-center">
                  <img onClick={setp4funtion}  className="img-seed-button3 curserPointer" width="65%" src="images/SeedPhase_ApplyButton.png" />
                </div>
              </div>


            </div>
            <div className="row d-flex justify-content-center">
             
              <div className="col-lg-4 col-md-6 col-sm-12 mt-4  parent-fill">
              <div className='marLeft'>
                <img width="370px" src="images/fill-bar.png" />
                <img className={`fill-bar_1  ${bar > 0  ? "visible" : "invisible"}`} src="images/fill-bar_1.png" />
                <img className={`fill-bar_2  ${bar >= 1 ? "visible" : "invisible"}`} src="images/fill-bar_2.png" />
                <img className={`fill-bar_3  ${bar >= 2 ? "visible" : "invisible"}`} src="images/fill-bar_3.png" />
                <img className={`fill-bar_4  ${bar >= 3 ? "visible" : "invisible"}`} src="images/fill-bar_3.png" />
                <img className={`fill-bar_5  ${bar >= 4 ? "visible" : "invisible"}`} src="images/fill-bar_4.png" />
                <img className={`fill-bar_6  ${bar >= 4 ? "visible" : "invisible"}`} src="images/fill-bar_4.png" />
                <img className={`fill-bar_7  ${bar >= 5 ? "visible" : "invisible"}`} src="images/fill-bar_5.png" />
                <img className={`fill-bar_8  ${bar >= 5 ? "visible" : "invisible"}`} src="images/fill-bar_5.png" />
                <img className={`fill-bar_9  ${bar >= 6 ? "visible" : "invisible"}`} src="images/fill-bar_6.png" />
                <img className={`fill-bar_10  ${bar >= 6 ? "visible" : "invisible"}`} src="images/fill-bar_7.png" />
                <img className={`fill-bar_11  ${bar >= 7 ? "visible" : "invisible"}`} src="images/fill-bar_8.png" />
                <img className={`fill-bar_12  ${bar >= 8 ? "visible" : "invisible"}`} src="images/fill-bar_9.png" />
                <img className={`fill-bar_13  ${bar >= 9 ? "visible" : "invisible"}`} src="images/fill-bar_9.png" />
                <img className={`fill-bar_13  ${bar >= 10 ? "visible" : "invisible"}`} src="images/fill-bar_9.png" />
                <div className="posi-text">
                  <p className="mb-0 text-fill">Hard Cap Fill</p>
                  <p className="text-num">10000000 V2 TOKENS</p>
                </div>

                <div className="posi1-text">
                  <p className="mb-0 text-fill">Soft Cap Fill</p>
                  <p className="text-num">5000000 V2 TOKENS</p>
                </div>
                </div>

              </div>
              <div className="col-lg-4 col-md-12 col-sm-12 col-xs-12 mt-4 pd-sec ">
                <div className="bg-form">
                  <h3 className="text-center text-swap pt-2 mb-2 ">Swap</h3>
                  <p className="text-center text-white pb-2 p-swap"> Swap Ratio: 1Crace= 0.55Cracer <br></br> (0.75cracer for diamond hands holders)</p>
                  <div style={{ marginLeft: "auto", marginRight: "auto", width: "88%" }} className="input-group ">
                    <input type="text" value={swap1input} onChange={handleChange} className="form-control border-input" aria-label="Recipient's username" aria-describedby="basic-addon2" />
                    <div className="input-group-append border-0">
                      <span className="input-group-text border-text" id="basic-addon2">V1 Tokens</span>
                    </div>
                  </div>

                  <img className="center-align" width="40px" src="images/toggle.png" />

                  <div style={{ marginLeft: "auto", marginRight: "auto", marginTop: "10px", width: "88%" }} className="input-group mb-3">
                    <input type="text" value={swap2input}  className="form-control border-input" aria-label="Recipient's username" aria-describedby="basic-addon2" />
                    <div className="input-group-append border-0">
                      <span className="input-group-text border-text" id="basic-addon2">V2 Tokens</span>
                    </div>
                  </div>
                  <img id="swapClick"  className={animation == true ? 'animated shake curserPointer center-align swap-margins': 'curserPointer center-align swap-margins'}  width="150px"  onClick={swap}  src="images/swap_button.png" />
              
                  <p className="text-center text-white p-swap" > Disclaimer: After the Seed Phase is over all the V1 Tokens will be used to pull out as much of the old token liquidity as possible. Please swap all your V1 Tokens as soon as possible as it will become useless after the Seed phase will end.

                  </p>
                </div>
              </div>


              <div className="col-lg-3 col-md-6 col-sm-12  col-xs-12 mt-4">
                <div className="d-flex justify-content-center flex-column">
                  <div className="d-flex justify-content-center text-center">
                  <Animated animationIn="bounceInRight" animationOut="fadeOut" isVisible={true}>
                    <img className="carConcept1" src="images/img1.jpeg" />
                    </Animated>
                  </div>
                  <div className="d-flex justify-content-center text-center">
                  <Animated animationIn="bounceInRight" animationOut="fadeOut" animationInDelay={300} isVisible={true}>
                    
                    <img className="ply_button curserPointer " onClick={RoadMap} src="images/ReloadedButton.png" />
                    </Animated>
                  </div>
                  <div className="d-flex justify-content-center text-center">
                  <Animated animationIn="bounceInRight" animationOut="fadeOut" animationInDelay={600} isVisible={true}>
                    <img className="carConcept2" src="images/img2.jpeg" />
                    </Animated>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div id="myModal" className="modal-oval">
                        <div className="modal-oval-content">
                            <Oval>
                                ariaLabel="loading-indicator"
                                height={100}
                                width={100}
                                strokeWidth={5}
                                color="red"
                                secondaryColor="yellow"
                            </Oval>
                            
                        </div>
          </div>

          
        
        </div>
  )
}

//export default Swap;

